export default __webpack_public_path__ + "static/media/user-dark.b0d9d717.svg";